import React from 'react'
import { useTranslation } from 'react-i18next'

import AddTikTokIdentity from './AddTikTokIdentity'
import AccessibleSocialPagesList from '../AccessibleSocialPagesList'
import SocialAuthChecker from '../../../../features/components/SocialAuthChecker'

import { TIKTOK_PLATFORM, TIKTOK_PROVIDER_PLATFORM } from '../../../../constants/selectLists/platformList'

import useCommonStyles from '../../../../styles/common/listPage'

const TikTokIdentities = () => {
  const commonClasses = useCommonStyles()

  const { t } = useTranslation()

  return (
    <div className={commonClasses.pageSection}>
      <div className={commonClasses.heading}>
        <div className={commonClasses.subTitle}>{t(`TikTok Identities`)}</div>
        <p>{t('Here you can create and manage the TikTok identities that TikTok ads will be delivered from.')}</p>
        <SocialAuthChecker
          platform={TIKTOK_PLATFORM}
          authFailureText="Please authenticate with TikTok to add an identity"
          contentAlign="left"
          hasPadding={false}
        >
          <div className={commonClasses.formButtons}>
            <AddTikTokIdentity />
          </div>
        </SocialAuthChecker>
      </div>
      <AccessibleSocialPagesList platformProvider={TIKTOK_PROVIDER_PLATFORM} />
    </div>
  )
}

export default TikTokIdentities
